<bolt-modal id="cancelClaimModal"
  heading="Before you go"
  #cancelClaimModal>
  <div class="bolt-body-copy-md bolt-space-bottom-lg">Your claim doesn’t have to be perfect to submit it. Take your best guess. You'll have the chance to fix things later.</div>
  <div class="bolt-space-bottom-lg">
    <bolt-button
      href="{{fAQPage}}"
    target="_blank">Let the FAQs help</bolt-button>
  </div>
  <div class="bolt-space-bottom-lg">
    <form [formGroup]="cancellationReasonsForm">
      <bolt-radio-group ngDefaultControl
        class="bolt-space-bottom-lg"
        formControlName="cancelReason"
        label="But if you have to go, tell us why"
        name="cancelReason">
        @for (cancellationReason of cancellationReasons; track cancellationReason) {
          <bolt-radio id={{cancellationReason?.value}}
            value={{cancellationReason?.value}}
            >
            {{cancellationReason.description}}
          </bolt-radio>
        }
      </bolt-radio-group>
      @if (cancellationReasonsForm.controls.cancelReason.value === 'other') {
        <bolt-textarea
          ngDefaultControl
          name="otherReason"
          formControlName="otherReason"
          label="Reason"
          showcount
          id="cancelClaimModal_OtherTxtField">
        </bolt-textarea>
      }
    </form>
  </div>
  <bolt-button-bar slot="modal-button-bar">
    <bolt-button slot="forward" (click)="sendExit()" type="solid">Send & exit</bolt-button>
    <bolt-button (click)="cancelClaimModalClose()" slot="cancel">Cancel</bolt-button>
  </bolt-button-bar>
</bolt-modal>
